import { render, staticRenderFns } from "./deanButtonGroup.vue?vue&type=template&id=bf5b4356&scoped=true"
import script from "./deanButtonGroup.vue?vue&type=script&lang=ts"
export * from "./deanButtonGroup.vue?vue&type=script&lang=ts"
import style0 from "./deanButtonGroup.vue?vue&type=style&index=0&id=bf5b4356&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5b4356",
  null
  
)

export default component.exports